function tsToHours(ts: bigint): number {
  return Number(ts / BigInt(3660));
}

export { tsToHours };
